import React, { memo } from 'react';
import {
    MenuItem,
    Select,
    styled,
    Box,
    SelectChangeEvent,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
    INDICIAIRE,
    MANTY_STATUS,
    ORG_CHART_HR_NAME,
    RECURRENCE,
    RETIREMENT_SYSTEM,
} from 'routes/HumanResourcesModule/business/definitions';
import { PAY_COMPONENT } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/helpers/constants';
import { SimulationResultData } from 'routes/HumanResourcesModule/business/types';

type GroupBySelectorProps = {
    setSelectedValue: (arg1: keyof SimulationResultData) => void;
    selectedValue: keyof SimulationResultData;
};

const StySelect = styled(Select, {
    name: 'StySelect',
})(({ theme }) => ({
    '.MuiSelect-select, .MuiSelect-select:focus': {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.lightGrey,
        fontSize: '13px',
        padding: '0.2rem 0.8rem',
        paddingRight: 32,
        height: 'max-content',
        width: 'max-content',
        borderRadius: '22px',
        textTransform: 'unset',
    },
    '.MuiOutlinedInput-notchedOutline, .MuiOutlinedInput-notchedOutline:focus':
        { border: 0, borderRadius: '22px' },
    'svg.MuiSelect-icon': {
        color: theme.palette.lightGrey,
    },
}));

const GroupBySelector: React.FC<GroupBySelectorProps> = ({
    setSelectedValue,
    selectedValue,
}) => {
    const { t } = useTranslation();

    const groupByElements = [
        {
            value: ORG_CHART_HR_NAME,
            label: t('humanResources.payState.orgChartHrs'),
            disabled: false,
            displayed: true,
        },
        {
            value: RECURRENCE,
            label: t('humanResources.settings.recurrence'),
            disabled: false,
            displayed: true,
        },
        {
            value: PAY_COMPONENT,
            label: t('humanResources.simulation.payComponent'),
            disabled: false,
            displayed: true,
        },
        {
            value: INDICIAIRE,
            label: t(`humanResources.settings.${INDICIAIRE}`),
            disabled: false,
            displayed: true,
        },
        {
            value: RETIREMENT_SYSTEM,
            label: t(`humanResources.settings.${RETIREMENT_SYSTEM}`),
            disabled: false,
            displayed: true,
        },
        {
            value: MANTY_STATUS,
            label: t(`humanResources.settings.${MANTY_STATUS}`),
            disabled: false,
            displayed: true,
        },
    ].filter((tab) => tab.displayed);

    return (
        <Box>
            <StySelect
                value={selectedValue}
                onChange={(
                    event: SelectChangeEvent<keyof SimulationResultData>,
                ) => {
                    // even by specifying the type of target value in SelectChangeEvent
                    // it is still considered as being a potential 'string', so
                    // we force it with 'as'.
                    setSelectedValue(
                        event.target.value as keyof SimulationResultData,
                    );
                }}
                disableUnderline
            >
                {groupByElements.map((el) => (
                    <MenuItem
                        key={el.value}
                        value={el.value}
                        disabled={el.disabled}
                    >
                        {el.label}
                    </MenuItem>
                ))}
            </StySelect>
        </Box>
    );
};

export default memo(GroupBySelector);
